// Single source of truth for all business content (bilingual).
// Swap INSTAGRAM_URL and logo asset here when provided by the clinic.

export const PHONE_DISPLAY = "0795914652";
export const PHONE_TEL = "+962795914652";
export const WHATSAPP_NUMBER = "962795914652";
export const INSTAGRAM_URL = "https://www.instagram.com/thera_prime/?hl=en";
export const FACEBOOK_URL = "https://web.facebook.com/profile.php?id=61578094606034";
export const EMAIL = "theraprime25@gmail.com";
export const MAPS_URL = "https://maps.app.goo.gl/LFoCdDTs2H5HQYEh9";
export const MAP_EMBED_URL = "https://maps.google.com/maps?q=32.522093,35.873670&z=16&output=embed";
export const GOOGLE_REVIEWS_URL =
    "https://www.google.com/search?q=TheraPrime+for+Physical+Therapy&kgmid=/g/11zjp4clk0";
export const GOOGLE_WRITE_REVIEW_URL =
    "https://www.google.com/maps/place/TheraPrime+for+Physical+Therapy/@32.5220818,35.8736724,17z/data=!4m8!3m7!1s0x151c77394c5508c5:0x87cbce28a55e280e!8m2!3d32.5220818!4d35.8736724!9m1!1b1!16s%2Fg%2F11zjp4clk0";

// Success-story videos: upload mp4 files to /public/assets/videos/ and add an
// entry per story. Shape: { src, poster?, title: {ar,en}, text: {ar,en} }
export const stories = [
    {
        src: "/assets/videos/story-hamada.mp4",
        poster: "/assets/videos/story-hamada.jpg",
        category: { ar: "التأهيل الرياضي · تأهيل إصابات الرباط الصليبي", en: "Sports Rehabilitation · Cruciate Ligament Injury" },
        title: { ar: "تحسّن في الركض والقفز: قصة حمادة مع التأهيل", en: "Improved Running and Jumping: Hamada's Rehabilitation Story" },
        summary: {
            ar: "بعد إصابة في الرباط الصليبي أثّرت في حركته، خضع حمادة الخالدي، لاعب نادي الجزيرة الأردني، للتأهيل في ثيرا برايم. وبعد نحو 20 جلسة، وصف الركض لديه بأنه ممتاز والقفز بأنه جيد جدًا.",
            en: "After a cruciate ligament injury affected his movement, Al-Jazeera player Hamada Al-Khaldi attended rehabilitation at TheraPrime. After approximately 20 sessions, he described his running as excellent and his jumping as very good.",
        },
        challenge: {
            ar: "عرجة خفيفة وصعوبات في القفز والثني والمشي بعد إصابة في الرباط الصليبي.",
            en: "A slight limp and difficulties with jumping, bending, and walking following a cruciate ligament injury.",
        },
        approach: {
            ar: "تأهيل يتضمّن تمارين للتوازن وتكنيك الحركة، إلى جانب تمارين تقوية الأطراف السفلية الظاهرة في الفيديو — نحو 20 جلسة علاجية.",
            en: "Rehabilitation with balance and movement-technique exercises, alongside the lower-limb strengthening shown in the video — approximately 20 sessions.",
        },
        outcome: {
            ar: "أفاد حمادة بتحسّن أدائه الحركي، ووصف الركض لديه بأنه ممتاز والقفز بأنه جيد جدًا.",
            en: "Hamada reports improved function, describing his running as excellent and his jumping as very good.",
        },
        quote: { ar: "«الحمد لله، الركض ممتاز» — حمادة الخالدي", en: "“Thank God, my running is excellent.” — Hamada Al-Khaldi" },
        cta: { ar: "احجز جلسة تقييم للعلاج الطبيعي", en: "Book a Physiotherapy Assessment" },
        thumb: { ar: "تقدّمي في الركض والقفز", en: "My Progress with Running and Jumping" },
    },
    {
        src: "/assets/videos/story-abeer.mp4",
        poster: "/assets/videos/story-abeer.jpg",
        category: { ar: "آلام القدم والكعب · العلاج الطبيعي", en: "Foot & Heel Pain · Physiotherapy" },
        title: { ar: "ألم أقل في الكعب: قصة عبير", en: "Relief from Heel Pain: Abeer's Story" },
        summary: {
            ar: "كانت آلام الكعب الشديدة تجعل تحميل الوزن على القدم واستخدام الدرج أمرًا صعبًا على عبير. وبعد مراجعتها ثيرا برايم، أفادت بانخفاض ملحوظ في الألم بحلول الجلسة العلاجية الخامسة.",
            en: "Severe heel pain made putting weight on her foot and using stairs difficult for Abeer. After attending TheraPrime, she reports noticeably less pain by her fifth treatment session.",
        },
        challenge: {
            ar: "ألم شديد في الكعب (مسمار عظم) جعل تحميل الوزن على القدم وصعود الدرج ونزوله أمرًا صعبًا.",
            en: "Severe heel pain (a heel spur) that made putting weight on her foot and going up and down stairs difficult.",
        },
        approach: {
            ar: "جلسات علاج طبيعي في ثيرا برايم مع الأخصائية نور الخرابشة، مع متابعة التحسّن جلسة بعد جلسة.",
            en: "Physiotherapy at TheraPrime with therapist Nour Al-Kharabsheh, with progress reviewed session by session.",
        },
        outcome: {
            ar: "أفادت عبير بانخفاض ملحوظ في الألم بحلول الجلسة العلاجية الخامسة.",
            en: "Abeer reports a considerable reduction in pain by her fifth session.",
        },
        quote: { ar: "«صرت إني تحسّنت من خامس جلسة» — عبير", en: "“I started to feel better by the fifth session.” — Abeer" },
        cta: { ar: "احجز جلسة تقييم للعلاج الطبيعي", en: "Book a Physiotherapy Assessment" },
        thumb: { ar: "رحلة عبير نحو ألم أقل في الكعب", en: "Abeer's Journey to Less Heel Pain" },
    },
    {
        src: "/assets/videos/story-salah.mp4",
        poster: "/assets/videos/story-salah.jpg",
        category: { ar: "آلام الركبة · العلاج الطبيعي", en: "Knee Pain · Physiotherapy" },
        title: { ar: "راحة الركبة من ثاني جلسة: قصة صلاح", en: "Knee Relief from the Second Session: Salah's Story" },
        summary: {
            ar: "آلام الركبة كانت تمنع صلاح ملحم من الوقوف الطويل في عمله ومن أداء تمارين الرجلين في النادي. بعد العلاج الطبيعي في ثيرا برايم، شعر براحة كبيرة منذ الجلسة الثانية.",
            en: "Knee pain kept Salah Melhem from standing long at work and from leg day at the gym. After physiotherapy at TheraPrime, he felt real relief from his second session.",
        },
        challenge: {
            ar: "ألم في الركبة بسبب الوقوف لفترات طويلة خلال العمل، وصعوبة أداء معظم تمارين الرجلين في النادي.",
            en: "Knee pain from standing for long periods at work, and being unable to perform most leg exercises at the gym.",
        },
        approach: {
            ar: "جلسات علاج طبيعي في ثيرا برايم، مع تحسّن ملموس بدأ منذ الجلسة الثانية.",
            en: "Physiotherapy sessions at TheraPrime, with noticeable relief beginning from the second session.",
        },
        outcome: {
            ar: "يقول صلاح إن ركبته ارتاحت كثيراً وعاد لأداء تمارينه مجدداً.",
            en: "Salah says his knee feels far more comfortable and he is back to his exercises.",
        },
        quote: { ar: "«ركبتي كثير ارتاحت» — صلاح ملحم", en: "“My knee felt so much better.” — Salah Melhem" },
        cta: { ar: "احجز جلسة تقييم للعلاج الطبيعي", en: "Book a Physiotherapy Assessment" },
        thumb: { ar: "ركبتي ارتاحت من ثاني جلسة", en: "My knee felt better from the second session" },
    },
    {
        src: "/assets/videos/story-mahmoud.mp4",
        poster: "/assets/videos/story-mahmoud.jpg",
        category: { ar: "تأهيل الأعصاب للأطفال · حركات لا إرادية", en: "Pediatric Neurological Rehab · Involuntary Movements" },
        title: { ar: "من عدم الجلوس إلى الوقوف بثبات: قصة محمود", en: "From Unable to Sit to Standing Steady: Mahmoud's Story" },
        summary: {
            ar: "جاء محمود إلى ثيرا برايم في الخامسة من عمره مع حركات لا إرادية ناتجة عن إصابة دماغية، غير قادر على الجلوس. بعد عام من العلاج المنتظم، أصبح يزحف ويقف بثبات أكبر — دون أدوية.",
            en: "Mahmoud came to TheraPrime at age five with involuntary movements from a brain injury, unable to sit. After about a year of consistent therapy, he now crawls and stands more steadily — without medication.",
        },
        challenge: {
            ar: "حركات لا إرادية ومنعكسات كثيرة، مع عدم القدرة على الجلوس أو التحكم بالحركة.",
            en: "Frequent involuntary movements and reflexes, with no ability to sit or control his movement.",
        },
        approach: {
            ar: "برنامج تأهيلي منتظم على مدار عام تقريباً لمعالجة المنعكسات وتحسين التوازن والتحكم الحركي.",
            en: "A consistent rehabilitation program over about a year, addressing reflexes and building balance and motor control.",
        },
        outcome: {
            ar: "أصبح محمود يثبّت جلوسه ويزحف ويقف بثبات أكبر — حتى على الكرة العلاجية — وكل ذلك دون أدوية.",
            en: "Mahmoud now sits steadily, crawls, and stands more stably — even on the therapy ball — all without medication.",
        },
        quote: { ar: "«وهذا الحمد لله من دون أدوية»", en: "“And this, thank God, is without medication.”" },
        cta: { ar: "احجز جلسة تقييم للعلاج الطبيعي", en: "Book a Physiotherapy Assessment" },
        thumb: { ar: "محمود يقف بثبات أكبر", en: "Mahmoud stands steadier now" },
    },
    {
        src: "/assets/videos/story-acl.mp4",
        poster: "/assets/videos/story-acl.jpg",
        category: { ar: "التأهيل بعد العمليات · الرباط الصليبي والغضروف الهلالي", en: "Post-Surgery Rehab · ACL & Meniscus" },
        title: { ar: "من العكازات إلى المشي خلال ست جلسات", en: "From Crutches to Walking in Six Sessions" },
        summary: {
            ar: "وصل المريض إلى ثيرا برايم بعد عملية قطع في الرباط الصليبي والغضروف الهلالي، غير قادر على التحميل على قدمه أو المشي دون عكازات. بعد ست جلسات فقط، ترك العكازات ومشى بدونها.",
            en: "The patient arrived at TheraPrime after ACL and meniscus surgery, unable to bear weight or walk without crutches. After only six sessions, he left the crutches and walked unaided.",
        },
        challenge: {
            ar: "عدم القدرة على التحميل على القدم أو المشي دون عكازات، مع ضعف عضلي واضح بعد عملية الرباط الصليبي والغضروف الهلالي.",
            en: "Inability to bear weight on the leg or walk without crutches, with marked muscle weakness after ACL and meniscus surgery.",
        },
        approach: {
            ar: "برنامج تأهيل بعد العملية على مدار ست جلسات، بهدف الوصول إلى الاستقلالية التامة في الحركة.",
            en: "A post-surgery rehabilitation program over six sessions, aiming for full independence in movement.",
        },
        outcome: {
            ar: "خلال ست جلسات فقط ترك المريض العكازات ومشى بدونها، والهدف القادم الاستقلالية التامة دون أي مساعدة.",
            en: "Within six sessions the patient left the crutches and walked without them; the next goal is complete independence without assistance.",
        },
        quote: { ar: "«وخلال ست جلسات فقط، المريض قدر يترك العكازات ويمشي بدونها»", en: "“Within six sessions only, the patient was able to leave the crutches and walk without them.”" },
        cta: { ar: "احجز جلسة تقييم للعلاج الطبيعي", en: "Book a Physiotherapy Assessment" },
        thumb: { ar: "ست جلسات فقط… بلا عكازات", en: "Six sessions only — no crutches" },
    },
    {
        src: "/assets/videos/story-migraine.mp4",
        poster: "/assets/videos/story-migraine.jpg",
        category: { ar: "الشقيقة (الصداع النصفي) · العلاج الطبيعي", en: "Migraine Care · Physiotherapy" },
        title: { ar: "شهران بلا مسكّنات: التعافي من الشقيقة", en: "Two Months Without Painkillers: Migraine Recovery" },
        summary: {
            ar: "عانت المريضة من شقيقة تتكرر ثلاث مرات شهرياً منذ سنتين، حتى احتاجت المسكّنات والإبر لتحمّل الألم. بعد شهرين من العلاج في ثيرا برايم مع الأخصائية نور الخرابشة، أصبحت بلا أي حبة مسكّن.",
            en: "The patient suffered migraines three times a month for two years, relying on painkillers and injections to cope. After two months of treatment at TheraPrime with therapist Nour Al-Kharabsheh, she no longer needs a single painkiller.",
        },
        challenge: {
            ar: "شقيقة تتكرر ثلاث مرات شهرياً، بألم يمتد من منتصف الرأس إلى العين والفك، مع اعتماد على المسكّنات والإبر.",
            en: "Migraines three times a month, with pain radiating from the center of the head to the eye and jaw, relying on painkillers and injections.",
        },
        approach: {
            ar: "خطة علاجية لمدة شهرين كاملين في ثيرا برايم مع الأخصائية نور الخرابشة.",
            en: "A two-month treatment plan at TheraPrime with therapist Nour Al-Kharabsheh.",
        },
        outcome: {
            ar: "تقول المريضة إنها أكملت شهرين كاملين دون أي حبة مسكّن، مؤكدة تحسّنها الكبير.",
            en: "She reports completing two full months without a single painkiller — a marked improvement.",
        },
        quote: { ar: "«بدون أي حبة مسكّن»", en: "“Without a single painkiller pill.”" },
        cta: { ar: "احجز جلسة تقييم للعلاج الطبيعي", en: "Book a Physiotherapy Assessment" },
        thumb: { ar: "شهران كاملان بلا مسكّنات", en: "Two full months without painkillers" },
    },
];

export const IMAGES = {
    hero: "/assets/hero-front.jpg",
    intro: "/assets/frame-5.jpg",
    clinic: "/assets/frame-3.jpg",
};

export const services = [
    {
        id: "rehab",
        icon: "activity",
        ar: { name: "التأهيل بعد الإصابات والعمليات", desc: "برامج إعادة تأهيل حركي متدرجة بعد الإصابات والعمليات الجراحية لاستعادة الحركة والقوة." },
        en: { name: "Rehabilitation after injuries & surgeries", desc: "Progressive motor rehabilitation after injuries and surgeries to restore movement and strength." },
    },
    {
        id: "pain",
        icon: "bone",
        ar: { name: "علاج آلام الظهر والرقبة والمفاصل والديسك", desc: "خطط علاج طبيعي لآلام الظهر والرقبة والمفاصل، تشمل علاج الديسك والانزلاق الغضروفي ضمن خطة تُبنى وفق تقييم حالتك." },
        en: { name: "Back, neck, joint & disc pain treatment", desc: "Physiotherapy for back, neck and joint pain — including disc and herniated-disc care — within a plan built on your assessment." },
    },
    {
        id: "manual",
        icon: "hand",
        ar: { name: "العلاج الطبيعي اليدوي", desc: "يعتمد نهجنا بدرجة كبيرة على العلاج اليدوي المدروس، بعد تقييم الحالة ووضع خطة علاج وتأهيل تناسب كل شخص." },
        en: { name: "Manual physical therapy", desc: "Our approach relies heavily on considered manual therapy — after assessing your case and building a treatment plan that fits you." },
    },
    {
        id: "neuro",
        icon: "brain",
        ar: { name: "علاج وتأهيل الأعصاب وما بعد الجلطات", desc: "إعادة تأهيل حركي لحالات ما بعد الجلطات وإصابات النخاع الشوكي واضطرابات التوازن، بخطط فردية مدروسة." },
        en: { name: "Neurological & post-stroke rehabilitation", desc: "Motor relearning after stroke, spinal cord injuries and balance disorders, through individual programs." },
    },
    {
        id: "sports",
        icon: "dumbbell",
        ar: { name: "إصابات الملاعب والتأهيل الرياضي", desc: "تأهيل إصابات الملاعب وبرامج تقوية العضلات لعودة آمنة وواثقة إلى نشاطك الرياضي." },
        en: { name: "Sports injuries & athletic rehabilitation", desc: "Rehabilitation for sports injuries plus muscle-strengthening programs for a safe, confident return to your sport." },
    },
    {
        id: "oncology",
        icon: "heartHandshake",
        ar: { name: "برامج خاصة لمرضى السرطان", desc: "برامج علاج طبيعي داعمة لمرضى السرطان خلال مراحل العلاج وبعدها." },
        en: { name: "Specialized programs for cancer patients", desc: "Supportive physical therapy programs for cancer patients during and after treatment." },
    },
    {
        id: "women",
        icon: "baby",
        ar: { name: "علاج وصحة المرأة قبل الولادة وبعدها", desc: "علاج طبيعي للنساء قبل الولادة وبعدها، ضمن قسم نسائي خاص بطاقم نسائي كامل." },
        en: { name: "Women's health before & after childbirth", desc: "Physiotherapy for women before and after childbirth, in a dedicated women's section with an all-female team." },
    },
    {
        id: "modalities",
        icon: "zap",
        ar: { name: "العلاج الكهربائي والموجات فوق الصوتية والليزر", desc: "جلسات العلاج الكهربائي والموجات فوق الصوتية والليزر ضمن خطتك العلاجية." },
        en: { name: "Electrical therapy, ultrasound & laser", desc: "Electrical therapy, ultrasound and laser sessions as part of your treatment plan." },
    },
    {
        id: "lymph",
        icon: "waves",
        ar: { name: "المساج العلاجي والليمفاوي", desc: "جلسات مساج علاجي وليمفاوي تساعد على الاستشفاء وتقليل التورم وتحفيز الدورة الليمفاوية." },
        en: { name: "Therapeutic & lymphatic massage", desc: "Therapeutic and lymphatic massage sessions supporting recovery, reducing swelling and stimulating lymphatic flow." },
    },
    {
        id: "recovery",
        icon: "heartPulse",
        ar: { name: "جلسات الاستشفاء العضلي", desc: "جلسات استشفاء عضلي تساعد جسدك على الاسترخاء وتجديد النشاط." },
        en: { name: "Muscle recovery sessions", desc: "Muscle recovery sessions that help your body relax and restore its energy." },
    },
];

export const copy = {
    ar: {
        meta: {
            title: "أفضل مركز علاج طبيعي وإعادة تأهيل في إربد | ثيرا برايم TheraPrime",
            description:
                "ثيرا برايم — مركز علاج طبيعي وإعادة تأهيل في إربد، دوار السفير. علاج الديسك والانزلاق الغضروفي، علاج آلام الرقبة والظهر والمفاصل، تأهيل ما بعد الجلطات وإصابات الملاعب، علاج طبيعي يدوي، وقسم نسائي بطاقم نسائي كامل. احجز: 0795914652",
        },
        brand: "العلاج الأمثل",
        brandShort: "العلاج الأمثل",
        brandLatin: "Thera Prime",
        brandFull: "مركز العلاج الأمثل لأنشطة العلاج الطبيعي",
        skip: "تخطَّ إلى المحتوى الرئيسي",
        header: {
            callUs: "اتصل بنا",
            book: "احجز موعدك",
            openMenu: "فتح القائمة",
            closeMenu: "إغلاق القائمة",
            menuTitle: "القائمة",
            switchLang: "English",
            switchLangAria: "التبديل إلى اللغة الإنجليزية",
        },
        nav: [
            {
                id: "services",
                icon: "care",
                label: "الرعاية والعلاج",
                children: [
                    { id: "services", icon: "services", label: "الخدمات العلاجية" },
                    { id: "approach", icon: "approach", label: "منهجنا في العلاج" },
                    { id: "equipment", icon: "equipment", label: "الأجهزة وطرق العلاج" },
                ],
            },
            {
                id: "why",
                icon: "about",
                label: "عن المركز",
                children: [
                    { id: "why", icon: "why", label: "لماذا العلاج الأمثل؟" },
                    { id: "women", icon: "women", label: "القسم النسائي" },
                    { id: "team", icon: "team", label: "فريقنا" },
                ],
            },
            {
                id: "reviews",
                icon: "stories",
                label: "تجارب المرضى",
                children: [
                    { id: "reviews", icon: "reviews", label: "تقييمات Google" },
                    { id: "stories", icon: "success", label: "قصص النجاح" },
                ],
            },
            {
                id: "hours",
                icon: "visit",
                label: "خطوتك التالية",
                children: [
                    { id: "hours", icon: "hours", label: "أوقات الدوام" },
                    { id: "faq", icon: "faq", label: "الأسئلة الشائعة" },
                    { id: "gallery", icon: "gallery", label: "جولة داخل المركز" },
                    { id: "contact", icon: "contact", label: "تواصل معنا" },
                ],
            },
        ],
        hero: {
            overline: "إربد — دوار السفير",
            titleLines: ["أفضل مركز علاج طبيعي", "وإعادة تأهيل في إربد"],
            subtitle:
                "ثيرا برايم — مركز علاج طبيعي وتأهيل في إربد يرافقك من أول تقييم وحتى نهاية رحلتك العلاجية، ببرامج تُبنى وفق تقييم حالتك، وأقسام منفصلة للرجال والنساء في دوار السفير.",
            ctaPrimary: "احجز عبر واتساب",
            ctaSecondary: "0795914652 اتصل:",
            imageAlt: "مركز علاج طبيعي في إربد — استقبال مركز ثيرا برايم",
            badge: "أقسام منفصلة للرجال والنساء",
        },
        reviews: {
            overline: "تقييمات Google",
            title: "ماذا يقول مرضانا",
            subtitle: "تجارب حقيقية من مرضانا على Google",
            aggregate: "69 تقييماً على Google",
            rating: "5.0",
            readMore: "اقرأ المزيد",
            readLess: "عرض أقل",
            prev: "التقييمات السابقة",
            next: "التقييمات التالية",
            postedOn: "على Google",
            writeUs: "قيّمنا على Google",
            loading: "جاري تحميل التقييمات…",
            unavailable: "التقييمات غير متاحة حالياً — يمكنك قراءتها مباشرة على Google.",
            viewOnGoogle: "شاهد تقييماتنا على Google",
        },
        stories: {
            overline: "قصص نجاح",
            title: "قصص نجاح مرضانا",
            subtitle: "رحلات حقيقية من التقييم إلى التعافي — بشهادة مرضى المركز.",
            details: "القصة الكاملة",
            challenge: "التحدّي",
            approach: "العلاج",
            outcome: "النتيجة",
        },
        gallery: {
            overline: "من داخل المركز",
            title: "جولة داخل العلاج الأمثل",
            items: [
                { src: "/assets/frame-1.jpg", alt: "واجهة الاستقبال في المركز" },
                { src: "/assets/frame-2.jpg", alt: "لوحة خدمات المركز التعريفية" },
                { src: "/assets/frame-3.jpg", alt: "بطاقات المركز التعريفية عند الاستقبال" },
                { src: "/assets/frame-4.jpg", alt: "ملصق تشريحي للجهاز العضلي" },
                { src: "/assets/frame-5.jpg", alt: "مجسم تشريحي داخل المركز أمام الشعار" },
            ],
        },
        intro: {
            overline: "تعرّف علينا",
            title: "رعاية علاجية مدروسة في قلب إربد",
            p1: "مركز العلاج الأمثل لأنشطة العلاج الطبيعي مركزٌ متخصص في إربد، يقدّم خدمات العلاج الطبيعي والتأهيل للرجال والنساء ضمن أقسام منفصلة، وببرامج علاجية تُصمم لكل حالة على حدة.",
            p2: "من إصابات العظام والعمليات الجراحية إلى تأهيل الأعصاب وصحة المرأة، نبني خطة علاج واضحة تبدأ بالتقييم وتستمر بالمتابعة، لتعود إلى نشاطك اليومي بثقة.",
            bullets: ["أقسام منفصلة للرجال والنساء", "برنامج علاجي فردي لكل حالة", "موقع سهل الوصول في دوار السفير"],
            imageAlt: "إعادة تأهيل حركي داخل مركز علاج طبيعي في إربد — ثيرا برايم",
        },
        services: {
            overline: "خدماتنا",
            title: "خدمات علاج طبيعي شاملة",
            subtitle: "خدمات علاجية وتأهيلية متكاملة تحت سقف واحد، تُقدَّم ضمن خطة علاجية واضحة تُبنى وفق تقييم كل حالة.",
        },
        approach: {
            overline: "منهجيتنا",
            title: "تقييم دقيق… وعلاج يدوي مدروس",
            steps: [
                { title: "الاستماع والتقييم", desc: "نبدأ بجلسة تقييم شاملة نستمع فيها إليك ونفهم حالتك وتاريخك الصحي." },
                { title: "خطة علاج شخصية", desc: "نصمم برنامجاً علاجياً يناسب احتياجك وأهدافك ووتيرة حياتك." },
                { title: "العلاج اليدوي والتأهيل", desc: "جلسات تعتمد بدرجة كبيرة على العلاج اليدوي المدروس، مع تمارين حركة وتوازن وتقوية حسب حالتك." },
                { title: "المتابعة والإرشاد", desc: "نتابع تقدّمك جلسة بعد جلسة ونرشدك إلى تمارين وعادات تحمي نتائج العلاج." },
            ],
        },
        why: {
            overline: "لماذا العلاج الأمثل؟",
            title: "تفاصيل تصنع الفرق في تجربتك العلاجية",
            imageAlt: "بطاقات هوية المركز عند الاستقبال",
            items: [
                { title: "أقسام منفصلة للرجال والنساء", desc: "خصوصية تامة وراحة أكبر خلال جميع الجلسات." },
                { title: "خطة علاج لكل حالة", desc: "لا قوالب جاهزة؛ برنامجك يُبنى على تقييمك وأهدافك." },
                { title: "موقع مركزي في إربد", desc: "دوار السفير، بناء فروتيلا، الطابق الأول — سهل الوصول." },
                { title: "حجز سهل وسريع", desc: "اتصل أو راسلنا عبر واتساب وسنرتّب موعدك بكل يسر." },
            ],
        },
        hours: {
            overline: "أوقات الدوام",
            title: "أوقات دوام تناسب يومك",
            women: "قسم السيدات",
            womenTime: "9:00 صباحاً – 6:00 مساءً",
            men: "قسم الرجال",
            menTime: "10:00 صباحاً – 8:00 مساءً",
            days: "السبت – الخميس",
            closed: "الجمعة: عطلة رسمية",
            note: "الدوام العام للمركز من السبت إلى الخميس، من 9:00 صباحاً حتى 8:00 مساءً. لتأكيد موعدك يرجى الاتصال بنا أو مراسلتنا عبر واتساب.",
        },
        ctas: {
            book: "احجز تقييمك الآن",
            whatsapp: "تواصل معنا عبر واتساب",
            session: "احجز جلسة علاج طبيعي",
            discover: "اكتشف خدماتنا",
        },
        women: {
            overline: "القسم النسائي",
            title: "قسم نسائي بطاقم نسائي كامل",
            text: "يوفّر القسم النسائي في ثيرا برايم خصوصية وراحة تامة للمراجعات، من خلال طاقم نسائي متخصص في العلاج الطبيعي للنساء — من آلام الظهر والمفاصل إلى صحة المرأة قبل الولادة وبعدها.",
            hours: "دوام القسم النسائي: 9:00 صباحاً – 6:00 مساءً، السبت – الخميس",
            points: ["طاقم نسائي كامل", "خصوصية تامة خلال جميع الجلسات", "علاج طبيعي للنساء قبل الولادة وبعدها", "برنامج يُبنى وفق تقييم كل حالة"],
            cta: "احجزي تقييمك الآن",
        },
        equipment: {
            overline: "الأجهزة وطرق العلاج",
            title: "الأجهزة وطرق العلاج في المركز",
            subtitle: "تشكيلة من الأجهزة وطرق العلاج المساندة التي تدخل ضمن خطة كل حالة — ويُحدَّث هذا القسم باستمرار.",
            items: [
                { icon: "zap", name: "العلاج الكهربائي", desc: "وحدة علاج كهربائي تُستخدم ضمن الخطة العلاجية بحسب تقييم الحالة." },
                { icon: "waves", name: "الموجات فوق الصوتية", desc: "جلسات موجات فوق صوتية ضمن البرنامج العلاجي." },
                { icon: "sparkles", name: "الليزر العلاجي", desc: "جلسات ليزر علاجي تُستخدم بحسب تقييم الحالة." },
                { icon: "hand", name: "العلاج اليدوي", desc: "أساليب علاج طبيعي يدوي مدروسة تُطبَّق بعد تقييم الحالة." },
                { icon: "activity", name: "تمارين الحركة والتوازن والتقوية", desc: "برامج تمارين موجّهة للحركة والتوازن وتقوية العضلات." },
                { icon: "heartPulse", name: "المساج العلاجي", desc: "جلسات مساج علاجي تدخل ضمن خطة الحالة." },
            ],
        },
        team: {
            overline: "فريقنا",
            title: "فريق ثيرا برايم",
            pendingTitle: "قريباً",
            pendingText: "نجهّز حالياً ملفات أعضاء فريقنا العلاجي — ترقّبوا التعريف بأخصائيي ثيرا برايم قريباً.",
        },
        form: {
            overline: "احجز موعدك",
            title: "اطلب موعدك عبر واتساب",
            subtitle: "عبّئ النموذج وسنجهّز لك رسالة واتساب جاهزة بكل التفاصيل — ما عليك سوى إرسالها.",
            name: "الاسم الكامل",
            namePh: "مثال: أحمد محمد",
            phone: "رقم الهاتف",
            phonePh: "07XXXXXXXX",
            service: "الخدمة المطلوبة",
            servicePh: "اختر الخدمة…",
            section: "القسم",
            sectionWomen: "قسم السيدات",
            sectionMen: "قسم الرجال",
            date: "التاريخ المفضل",
            time: "الوقت المفضل",
            timePh: "اختر الوقت…",
            notes: "ملاحظات قصيرة (اختياري)",
            notesPh: "أي تفاصيل تودّ إخبارنا بها…",
            submit: "إرسال الطلب عبر واتساب",
            disclaimer: "إرسال الطلب لا يعني تأكيد الموعد؛ سيتواصل معك المركز لتأكيد الحجز.",
            waError: "تعذّر فتح واتساب تلقائياً.",
            waErrorAction: "اضغط هنا لفتح المحادثة يدوياً",
            waReady: "جهّزنا رسالتك في واتساب — أرسلها ليصلنا طلبك.",
            errors: {
                name: "يرجى إدخال الاسم الكامل.",
                phone: "يرجى إدخال رقم هاتف صحيح.",
                service: "يرجى اختيار الخدمة المطلوبة.",
                section: "يرجى اختيار القسم.",
                date: "يرجى اختيار التاريخ المفضل.",
                datePast: "لا يمكن اختيار تاريخ سابق؛ يرجى اختيار تاريخ اليوم أو تاريخ قادم.",
                time: "يرجى اختيار الوقت المفضل.",
            },
            wa: {
                title: "طلب حجز موعد — مركز العلاج الأمثل",
                name: "الاسم",
                phone: "الهاتف",
                service: "الخدمة",
                section: "القسم",
                women: "قسم السيدات",
                men: "قسم الرجال",
                date: "التاريخ",
                time: "الوقت",
                notes: "ملاحظات",
                footer: "أرجو التواصل معي لتأكيد الموعد.",
            },
        },
        faq: {
            overline: "الأسئلة الشائعة",
            title: "كل ما تحتاج معرفته قبل زيارتك",
            items: [
                { q: "كيف أحجز موعداً؟", a: "يمكنك الحجز بسهولة عبر الاتصال بنا على 0795914652 أو بإرسال طلب عبر نموذج واتساب في الموقع، وسيتواصل معك المركز لتأكيد الموعد." },
                { q: "هل أحتاج إلى تحويلة طبية؟", a: "لا تحتاج إلى تحويلة مسبقة لحجز موعد. وإن كانت لديك تقارير أو صور طبية سابقة، يُفضَّل إحضارها لجلسة التقييم الأولى." },
                { q: "كم تستغرق الجلسة؟ وكم جلسة سأحتاج؟", a: "تختلف مدة الجلسة وعدد الجلسات من حالة إلى أخرى؛ يحدد المعالج ذلك بعد جلسة التقييم الأولى ضمن خطة علاج واضحة." },
                { q: "ماذا أحضر معي في أول زيارة؟", a: "أحضر أي تقارير أو صور طبية متوفرة لديك، وارتدِ ملابس مريحة تسمح بحرية الحركة خلال التقييم والعلاج." },
                { q: "هل الأقسام منفصلة للرجال والنساء؟", a: "نعم، يضم المركز قسماً منفصلاً للسيدات وآخر للرجال، بأوقات دوام مختلفة لضمان خصوصيتك وراحتك." },
                { q: "أين يقع المركز؟", a: "في إربد، دوار السفير، بناء فروتيلا، الطابق الأول — ويمكنك فتح الموقع مباشرة على خرائط جوجل من قسم التواصل." },
            ],
        },
        contact: {
            overline: "تواصل معنا",
            title: "نسعد بخدمتك في إربد",
            mapFrameTitle: "موقع المركز على خرائط جوجل",
            addressLabel: "العنوان",
            address: "إربد، الأردن — دوار السفير، بناء فروتيلا، الطابق الأول",
            mapLink: "افتح في خرائط جوجل",
            phoneLabel: "الهاتف",
            whatsappLabel: "واتساب",
            instagramLabel: "إنستغرام",
            instagramText: "تابعنا على إنستغرام",
            facebookLabel: "فيسبوك",
            facebookText: "تابعنا على فيسبوك",
            emailLabel: "البريد الإلكتروني",
        },
        footer: {
            quickLinks: "روابط سريعة",
            contactTitle: "تواصل",
            hoursTitle: "أوقات الدوام",
            medicalNote: "المحتوى في هذا الموقع تعريفي ولا يغني عن الاستشارة الطبية.",
            rights: "مركز العلاج الأمثل لأنشطة العلاج الطبيعي. جميع الحقوق محفوظة.",
        },
        mobileBar: { call: "اتصال", book: "حجز موعد" },
        theme: { toDark: "تفعيل الوضع الداكن", toLight: "تفعيل الوضع الفاتح" },
        backToTop: "العودة إلى الأعلى",
    },
    en: {
        meta: {
            title: "TheraPrime | Leading Physical Therapy & Rehabilitation Center in Irbid",
            description:
                "TheraPrime — physical therapy and rehabilitation in Irbid, Jordan: disc and back/neck/joint pain care, post-stroke and sports-injury rehabilitation, manual therapy, and a women's section with an all-female team. Al Safeer Circle, Frutella Building, First Floor. Call 0795914652.",
        },
        brand: "Thera Prime",
        brandShort: "Thera Prime",
        brandLatin: "PHYSICAL THERAPY",
        brandFull: "Thera Prime Physical Therapy",
        skip: "Skip to main content",
        header: {
            callUs: "Call us",
            book: "Book Appointment",
            openMenu: "Open menu",
            closeMenu: "Close menu",
            menuTitle: "Menu",
            switchLang: "العربية",
            switchLangAria: "Switch to Arabic",
        },
        nav: [
            {
                id: "services",
                icon: "care",
                label: "Care & Treatment",
                children: [
                    { id: "services", icon: "services", label: "Our Services" },
                    { id: "approach", icon: "approach", label: "Our Approach" },
                    { id: "equipment", icon: "equipment", label: "Equipment & Methods" },
                ],
            },
            {
                id: "why",
                icon: "about",
                label: "About the Clinic",
                children: [
                    { id: "why", icon: "why", label: "Why TheraPrime" },
                    { id: "women", icon: "women", label: "Women's Section" },
                    { id: "team", icon: "team", label: "Our Team" },
                ],
            },
            {
                id: "reviews",
                icon: "stories",
                label: "Patient Stories",
                children: [
                    { id: "reviews", icon: "reviews", label: "Google Reviews" },
                    { id: "stories", icon: "success", label: "Success Stories" },
                ],
            },
            {
                id: "hours",
                icon: "visit",
                label: "Plan Your Visit",
                children: [
                    { id: "hours", icon: "hours", label: "Opening Hours" },
                    { id: "faq", icon: "faq", label: "FAQ" },
                    { id: "gallery", icon: "gallery", label: "Inside the Clinic" },
                    { id: "contact", icon: "contact", label: "Contact Us" },
                ],
            },
        ],
        hero: {
            overline: "Irbid — Al Safeer Circle",
            titleLines: ["Leading physical therapy", "and rehabilitation in Irbid"],
            subtitle:
                "TheraPrime — a physical therapy and rehabilitation center in Irbid, walking with you from your first assessment through your recovery journey, with programs built on your assessment and separate men's and women's sections at Al Safeer Circle.",
            ctaPrimary: "Book via WhatsApp",
            ctaSecondary: "Call: 0795914652",
            imageAlt: "Physical therapy center in Irbid — the TheraPrime reception",
            badge: "Separate men's & women's sections",
        },
        reviews: {
            overline: "Google reviews",
            title: "What Our Patients Say",
            subtitle: "Real experiences from our patients on Google",
            aggregate: "69 reviews on Google",
            rating: "5.0",
            readMore: "Read more",
            readLess: "Read less",
            prev: "Previous reviews",
            next: "Next reviews",
            postedOn: "on Google",
            writeUs: "Review us on Google",
            loading: "Loading reviews…",
            unavailable: "Reviews are temporarily unavailable — you can read them directly on Google.",
            viewOnGoogle: "View our reviews on Google",
        },
        stories: {
            overline: "Success stories",
            title: "Our patients' success stories",
            subtitle: "Real journeys from assessment to recovery — told by the clinic's patients.",
            details: "The full story",
            challenge: "The challenge",
            approach: "Treatment",
            outcome: "Outcome",
        },
        gallery: {
            overline: "Inside the clinic",
            title: "A look inside Thera Prime",
            items: [
                { src: "/assets/frame-1.jpg", alt: "The clinic's reception area" },
                { src: "/assets/frame-2.jpg", alt: "The clinic's services banner" },
                { src: "/assets/frame-3.jpg", alt: "Thera Prime business cards at the front desk" },
                { src: "/assets/frame-4.jpg", alt: "Anatomical poster of the muscular system" },
                { src: "/assets/frame-5.jpg", alt: "Anatomical skeleton model in front of the clinic logo" },
            ],
        },
        intro: {
            overline: "About the clinic",
            title: "Considered, professional care in the heart of Irbid",
            p1: "Thera Prime Physical Therapy is a specialized center in Irbid offering physical therapy and rehabilitation for men and women in separate sections, with treatment programs designed for each individual case.",
            p2: "From orthopedic injuries and post-surgical recovery to neurological rehabilitation and women's health, we build a clear treatment plan that begins with assessment and continues with follow-up — so you return to your daily life with confidence.",
            bullets: ["Separate men's and women's sections", "An individual program for every case", "An easy-to-reach location at Al Safeer Circle"],
            imageAlt: "Motor rehabilitation inside a physical therapy center in Irbid — TheraPrime",
        },
        services: {
            overline: "Our services",
            title: "Comprehensive physical therapy services",
            subtitle: "A complete range of therapeutic and rehabilitative services under one roof, delivered within a clear plan built on each case's assessment.",
        },
        approach: {
            overline: "Our approach",
            title: "Careful assessment. Considered manual therapy.",
            steps: [
                { title: "Listen & assess", desc: "We begin with a thorough assessment session where we listen to you and understand your condition and health history." },
                { title: "A personal plan", desc: "We design a treatment program that fits your needs, your goals, and the rhythm of your life." },
                { title: "Manual therapy & rehabilitation", desc: "Sessions that rely heavily on considered manual therapy, with movement, balance and strengthening exercises tailored to you." },
                { title: "Follow up & guide", desc: "We track your progress session by session and guide you with exercises and habits that protect your results." },
            ],
        },
        why: {
            overline: "Why Thera Prime?",
            title: "Details that make the difference in your care",
            imageAlt: "Thera Prime business cards at the front desk",
            items: [
                { title: "Separate men's & women's sections", desc: "Complete privacy and greater comfort throughout every session." },
                { title: "A plan for every case", desc: "No ready-made templates — your program is built on your assessment and your goals." },
                { title: "A central Irbid location", desc: "Al Safeer Circle, Frutella Building, First Floor — easy to reach." },
                { title: "Easy, fast booking", desc: "Call us or message us on WhatsApp and we will arrange your appointment with ease." },
            ],
        },
        hours: {
            overline: "Working hours",
            title: "Hours that fit your day",
            women: "Women's Section",
            womenTime: "9:00 AM – 6:00 PM",
            men: "Men's Section",
            menTime: "10:00 AM – 8:00 PM",
            days: "Saturday – Thursday",
            closed: "Friday: Closed (official holiday)",
            note: "The clinic is open Saturday to Thursday, 9:00 AM – 8:00 PM. To confirm your appointment, please call us or message us on WhatsApp.",
        },
        ctas: {
            book: "Book Your Assessment Now",
            whatsapp: "Chat with us on WhatsApp",
            session: "Book a Physiotherapy Session",
            discover: "Explore our services",
        },
        women: {
            overline: "Women's section",
            title: "A women's section with an all-female team",
            text: "The women's section at TheraPrime offers complete privacy and comfort through a dedicated female team specializing in women's physiotherapy — from back and joint pain to women's health before and after childbirth.",
            hours: "Women's section hours: 9:00 AM – 6:00 PM, Saturday – Thursday",
            points: ["An all-female team", "Complete privacy during every session", "Women's physiotherapy before and after childbirth", "A program built on each case's assessment"],
            cta: "Book Your Assessment Now",
        },
        equipment: {
            overline: "Equipment & methods",
            title: "Equipment and treatment methods at the clinic",
            subtitle: "A range of supportive devices and treatment methods used within each case's plan — this section is updated regularly.",
            items: [
                { icon: "zap", name: "Electrical therapy", desc: "An electrical therapy unit used within the treatment plan as the case requires." },
                { icon: "waves", name: "Ultrasound therapy", desc: "Ultrasound sessions within the treatment program." },
                { icon: "sparkles", name: "Therapeutic laser", desc: "Laser therapy sessions applied according to the case assessment." },
                { icon: "hand", name: "Manual therapy", desc: "Considered manual physiotherapy techniques applied after assessment." },
                { icon: "activity", name: "Movement, balance & strengthening", desc: "Guided exercise programs for movement, balance and muscle strengthening." },
                { icon: "heartPulse", name: "Therapeutic massage", desc: "Therapeutic massage sessions included in the case plan." },
            ],
        },
        team: {
            overline: "Our team",
            title: "The TheraPrime team",
            pendingTitle: "Coming soon",
            pendingText: "We are preparing our therapy team's profiles — stay tuned to meet TheraPrime's specialists soon.",
        },
        form: {
            overline: "Request an appointment",
            title: "Request your appointment via WhatsApp",
            subtitle: "Fill in the form and we will prepare a ready-to-send WhatsApp message with every detail — all you have to do is press send.",
            name: "Full name",
            namePh: "e.g. Ahmad Mohammad",
            phone: "Phone number",
            phonePh: "07XXXXXXXX",
            service: "Required service",
            servicePh: "Select a service…",
            section: "Section",
            sectionWomen: "Women's section",
            sectionMen: "Men's section",
            date: "Preferred date",
            time: "Preferred time",
            timePh: "Select a time…",
            notes: "Short notes (optional)",
            notesPh: "Anything you would like us to know…",
            submit: "Send request via WhatsApp",
            disclaimer: "Submitting this request does not confirm your appointment; the clinic will contact you to confirm the booking.",
            waError: "We couldn't open WhatsApp automatically.",
            waErrorAction: "Tap here to open the chat manually",
            waReady: "Your message is ready in WhatsApp — send it so we receive your request.",
            errors: {
                name: "Please enter your full name.",
                phone: "Please enter a valid phone number.",
                service: "Please select the required service.",
                section: "Please choose a section.",
                date: "Please choose your preferred date.",
                datePast: "Past dates cannot be selected; please choose today or an upcoming date.",
                time: "Please choose your preferred time.",
            },
            wa: {
                title: "Appointment Request — Thera Prime Physical Therapy",
                name: "Name",
                phone: "Phone",
                service: "Service",
                section: "Section",
                women: "Women's section",
                men: "Men's section",
                date: "Date",
                time: "Time",
                notes: "Notes",
                footer: "Please contact me to confirm the appointment.",
            },
        },
        faq: {
            overline: "FAQ",
            title: "Everything you need to know before your visit",
            items: [
                { q: "How do I book an appointment?", a: "You can book easily by calling us at 0795914652 or by sending a request through the WhatsApp form on this page — the clinic will contact you to confirm your appointment." },
                { q: "Do I need a doctor's referral?", a: "You do not need a prior referral to book. If you have previous medical reports or imaging, it is best to bring them to your first assessment session." },
                { q: "How long is a session, and how many will I need?", a: "Session length and the number of sessions vary from case to case; your therapist will determine both after the first assessment, within a clear treatment plan." },
                { q: "What should I bring to my first visit?", a: "Bring any medical reports or imaging you have, and wear comfortable clothing that allows free movement during assessment and treatment." },
                { q: "Are the men's and women's sections separate?", a: "Yes. The center has a separate women's section and a separate men's section, with different working hours to ensure your privacy and comfort." },
                { q: "Where is the clinic located?", a: "In Irbid, at Al Safeer Circle, Frutella Building, First Floor — you can open the location directly in Google Maps from the contact section." },
            ],
        },
        contact: {
            overline: "Contact & location",
            title: "We're here for you in Irbid",
            mapFrameTitle: "Clinic location on Google Maps",
            addressLabel: "Address",
            address: "Al Safeer Circle, Frutella Building, First Floor, Irbid, Jordan",
            mapLink: "Open in Google Maps",
            phoneLabel: "Phone",
            whatsappLabel: "WhatsApp",
            instagramLabel: "Instagram",
            instagramText: "Follow us on Instagram",
            facebookLabel: "Facebook",
            facebookText: "Follow us on Facebook",
            emailLabel: "Email",
        },
        footer: {
            quickLinks: "Quick links",
            contactTitle: "Contact",
            hoursTitle: "Working hours",
            medicalNote: "The content of this website is informational and is not a substitute for medical advice.",
            rights: "Thera Prime Physical Therapy. All rights reserved.",
        },
        mobileBar: { call: "Call", book: "Book" },
        theme: { toDark: "Switch to dark mode", toLight: "Switch to light mode" },
        backToTop: "Back to top",
    },
};
